import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import SignInPage from './components/SignIn/SignInPage';
import ForgottenPassword from './components/SignIn/ForgottenPassword';
import SignUpPage from './components/SignUpPage';
import * as ROUTES from './constants/routes';
import HomePage from './components/Home/HomePage';
import TopbarAccount from './components/Account/Team/TopbarAccount';
import ManagerPage from './components/Account/Manager/ManagerPage';
import TeamPage from './components/Account/Team/TeamPage';
import PeersPage from './components/Account/Peers/PeersPage';
import TopbarPilotage from './components/Driving/TopbarPilotage';
import SearchPage from './components/Search/SearchPage';
import ChallengeCreatorPage from './components/Challenge/ChallengeCreatorPage';
import ChallengePage from './components/Challenge/ChallengePage'
import Loading from './components/Loading';
import { withFirebase } from './components/Firebase';
import Navbar from './components/Navbar';
import EmailVerif from './components/EmailVerif/EmailVerif';
import Footer from './components/Footer/Footer';

class ZideUpApp extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show: false,
      user: null
    }
  }

  componentDidMount() {
    this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {
      if (window.location.search === '?rgpdVerified') {
        sessionStorage.setItem('rgpdVerified', true);
      }
      const rgpdVerified = sessionStorage.getItem('rgpdVerified');
      const origin = window.location.origin;
      if (currentUser === null) {
        if (!rgpdVerified) {
          window.location.replace(`https://pod.web.rgpd.dev-id.fr/?bundleId=zideeUp.ZideeUp&redirect_url=${origin}/login?rgpdVerified`)
        }
        else if (window.location.pathname !== '/login') {
          window.location.replace(`/login`)
        }
        return
      }
      this.setState({
        show: true,
        user: currentUser
      })
      if (!rgpdVerified) {
        window.location.replace(`https://pod.web.rgpd.dev-id.fr/?bundleId=zideeUp.ZideeUp&redirect_url=${origin}/home?rgpdVerified`)
      }
    })
  }

  componentWillUnmount() {
  }

  scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  render() {

    const { show, user } = this.state;

    return (
      <>
        {show ?
          <>
            {user.emailVerified ?
              <>
                <Navbar></Navbar>
                <Switch>
                  <Route path={ROUTES.HOME} component={HomePage} />
                  <Route path={ROUTES.ACCOUNT} component={TopbarAccount} />
                  <Route path={ROUTES.MANAGER} component={ManagerPage} />
                  <Route path={ROUTES.TEAM} component={TeamPage} />
                  <Route path={ROUTES.PEERS} component={PeersPage} />
                  <Route path={ROUTES.DRIVING} component={TopbarPilotage} />
                  <Route path={ROUTES.SEARCH} component={SearchPage} />
                  <Route path={ROUTES.CHALLENGE} component={ChallengeCreatorPage} />
                  <Route path={ROUTES.RECEIVED} render={(props) => <TopbarAccount {...props} value={1} />} />
                  <Route path="/capsule/:id" component={ChallengePage} />
                  <Route exact path={ROUTES.EMAIL_VERIF} component={EmailVerif} />
                  <Route render={() => <Redirect to="/home"></Redirect>} />
                </Switch>
                <Footer></Footer>
              </> :
              <Switch>
                <Route exact path={ROUTES.EMAIL_VERIF} component={EmailVerif} />
                <Route render={() => <Redirect to="/email"></Redirect>} />
              </Switch>
            }
          </> :
          <Switch>
            <Route exact path={ROUTES.SIGN_IN} component={SignInPage} />
            <Route exact path={ROUTES.FORGOTTEN_PASSWORD} component={ForgottenPassword} />
            <Route exact path={ROUTES.SIGN_UP} component={SignUpPage} />
            <Route render={() => <Loading />} />
          </Switch>
        }
      </>
    )
  }
}

const App = withFirebase(ZideUpApp)

export default App;
